<template>
  <div class="loginContainer">
    <div class="loginContent">
      <div class="cancel-btn" @click="close">
        X
      </div>
      <div class="title">{{this.$t('lang.confirmWin.confirm')}}</div>
      <div class="body">
        <div class="text1">{{hintText}}</div>
        <div class="butons">
          <div class="yes-btn" @click="yesClick">{{this.$t('lang.confirmWin.deposit')}}</div>
      </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Confirm',
  props: ['confirmToDo', 'hintText'],
  data () {
    return {
    }
  },
  methods: {
    yesClick () {
      if (this.confirmToDo) {
        this.confirmToDo()
      }
      this.$store.state.confirmWinShow = false
    },
    close () {
      this.$store.state.confirmWinShow = false
    }
  }
}
</script>

<style lang="less" scoped>
  .loginContainer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.8);
    z-index: 10;
    .loginContent {
      position: absolute;
      top: 50%;
      left: 50%;
      width: calc(100% - 50px);
      height: 100px;
      transform: translate(-50%,-50%);
      >img {
        position: absolute;
        top: -28px;
        right: -28px;
        width: 28px;
      }
      .title {
        font-size: 24px;
        line-height: 55px;
        font-weight: bold;
        color: #543200;
        text-align: center;
        background: #F6D9AA;
        border-radius: 10px 10px 0 0;
      }
      .body {
        padding: 15px 22px;
        margin-bottom: 40px;
        background: #212324;
        border-radius: 0 0 10px 10px;
        .text1 {
          font-size: 18px;
          line-height: 21px;
          color: #F6D9AA;
        }
        .butons{
          display: flex;
          justify-content:center;
        }
        .yes-btn{
          background: #F6D9AA;
          border-radius: 6px;
          line-height: 20px;
          padding: 12px 0px;
          text-align: center;
          color: #000D2E;
          font-size: 20px;
          margin: 20px 0 0 0;
          width:80vw;
        }
        .no-btn{
          background: #F6D9AA;
          border-radius: 6px;
          line-height: 20px;
          padding: 12px 0px;
          text-align: center;
          color: #000D2E;
          font-size: 20px;
          margin-top: 20px;
          width:100px;
        }
      }
      .cancel-btn{
        position: absolute;
        top: 15px;
        right: 4px;
        width: 25px;
        height: 25px;
        font-size: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ConfirmWin/confirmWithOneButton.vue